import { render } from "./ModalStockOpnameDetail.vue?vue&type=template&id=db677a80"
import script from "./ModalStockOpnameDetail.vue?vue&type=script&lang=js"
export * from "./ModalStockOpnameDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__